import { Component, OnInit, ElementRef } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { UsuarioService } from '../../../services/usuario.service';
import { SessionService } from '../../../services/session.service';
import { EmpresaService } from '../../../services/empresa.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConfigService } from '../../../config/config-service';
import { SweetMessage } from '../../../config/sweet-message';
import { ParametroService } from '../../../services/parametro.service';
import { environment } from '../../../../environments/environment';

declare var $:any;

@Component({
  selector: 'login-principal',
  templateUrl: './login-principal.component.html',
  styleUrls: ['./login-principal.component.css'],
  providers: [LoginService, UsuarioService, EmpresaService, ParametroService]
})
export class LoginPrincipalComponent implements OnInit {
	public busy: boolean = false;
	private sidebarVisible: boolean;
	private toggleButton;
	public textButtonLogin: String;
	public empresa: string;
	public config: ConfigService;
	public FACT_USER: String;
    public FACT_PASS:String;
	public FACT_USER_ID:String;
	public msgSweet: SweetMessage;
	public factelec_api: String;

	constructor(
		public loginService: LoginService,
		private usuarioService: UsuarioService,
		private empresaService: EmpresaService,
		private ss: SessionService,
		private NavRoute: Router,
		private element : ElementRef,
		private parametroService: ParametroService,
	) {
		this.sidebarVisible = false;
		this.textButtonLogin = "Iniciar sesión";
		this.config = new ConfigService();
		this.FACT_PASS = "";
		this.FACT_USER = "";
		this.FACT_USER_ID = "";
		this.msgSweet = new SweetMessage();
		this.factelec_api = environment.factelec_api;
		let codigo_empresa = localStorage.getItem('codigo_empresa');

		if( codigo_empresa ){
			this.empresa = codigo_empresa;
		}else{
			this.empresa = "";
		}
	}

	checkFullPageBackgroundImage(){
        var $page = $('.full-page');
        var image_src = $page.data('image');

        if(image_src !== undefined){
            var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
            $page.append(image_container);
        }
	};

	ngOnInit() {
		this.checkFullPageBackgroundImage();

		var navbar : HTMLElement = this.element.nativeElement;
		this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
		
		setTimeout(function(){
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 700)
	}

	auth(usuario, password){
		let empresa = this.empresa;
		if( empresa.trim().length === 0 ){
			this.msgSweet.showMessage('error-message', "El campo empresa está vacio");
			return;
		}

		if( usuario.trim().length === 0 ){
			this.msgSweet.showMessage('error-message', "El campo usuario está vacio");
			return;
		}

		if( password.trim().length === 0 ){			
			this.msgSweet.showMessage('error-message', "El campo contraseña está vacio");
			return;
		}

		this.busy = true;
		this.textButtonLogin = "Espere...";
		this.loginService.getCteByCodigo(empresa).subscribe(
			res => {
				let host_api = res.host_api;
				let dbname = res.dbname;
				sessionStorage.setItem('host_api', host_api);
				sessionStorage.setItem("dbname", dbname);
				localStorage.setItem('codigo_empresa',empresa);
				
				let data = {
					usuario: usuario,
					password: password
				};
				this.textButtonLogin = "Autenticando...";
				this.loginService.auth(host_api, data, dbname).subscribe(response => {
					sessionStorage.setItem('api-token', response.data.token);
					this.usuarioService.getByUser(data.usuario, dbname).subscribe(
						res => {
							this.textButtonLogin = "Accediendo...";

							this.empresaService.getConfApi().subscribe(
								resConfig => {
									let facelect_user = resConfig.FACT_USER;
									let facelect_pass = resConfig.FACT_PASS;

									res['fact_user'] = facelect_user;

									let host = this.factelec_api;
									let data = {
										usuario: facelect_user,
										password: facelect_pass
									};
									if(res.mod_felectronica && facelect_user.toString().trim() !== "" && facelect_pass.toString().trim() !== ""){
										this.loginService.authFactElectronica(host, data).subscribe(
											datafact => {
												sessionStorage.setItem('fact-api-token', datafact.data.token);
												let p1 = this.ss.setData(res);
												let p2 = this.setParametros();

												Promise.all([p1,p2]).then(()  => this.NavRoute.navigate(['desktop']));

												this.empresaService.GetEmpresaID_Fact(res.emp_ruc).subscribe(
													resEmpresaFact => {
														let empresa_id_FACT = resEmpresaFact.data[0].id;
														sessionStorage.setItem('fact_id', empresa_id_FACT);
													},
													err => {

													}
												);
											},
											err => {
												this.busy = false;
												this.textButtonLogin = "Ingresar";
												this.msgSweet.showMessage('error-message', "Error 6: " +  err);
											}
										)
										//this.ss.setData(res).then(()  => this.NavRoute.navigate(['desktop']));
									}else{
										let p1 = this.ss.setData(res);
										let p2 = this.setParametros();
										Promise.all([p1,p2]).then(()  => this.NavRoute.navigate(['desktop']));
									}
								},
								err => {
									this.busy = false;
									this.textButtonLogin = "Ingresar";
									this.msgSweet.showMessage('error-message', "Error 5: " +  err);
								}
							);
						},
						err => {
							this.busy = false;
							this.textButtonLogin = "Ingresar";
							this.msgSweet.showMessage('error-message', "Error 4: " +  err);
						}
					);
				},
				err => {
					this.busy = false;
					this.textButtonLogin = "Ingresar";
					this.msgSweet.showMessage('error-message', "Error 3: " +  err.json().message);
				});
			},
			err => {
				this.busy = false;
				this.textButtonLogin = "Ingresar";
				if( err.status === 404 ){
					this.msgSweet.showMessage('error-message', "Error 2 : No se encontró la empresa " + empresa.toString().toUpperCase() + "");
				}else{
					this.msgSweet.showMessage('error-message', "Error 1: " + err.status + " - " + err.json().message);
				}
			}
		);
	}

	setParametros(){
		let p1 = this.getPreciosAdicionales();
		let p2 = this.getPrecioUnitarioEditable();
		let p3 = this.getParamNumeroDecimales();
		let p4 = this.getIVA();
		let p5 = this.getParamDocumentoManual();

		return Promise.all([p1,p2,p3,p4,p5]); //.then();
	}

	getPreciosAdicionales(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
					let is_precios = (res.valor.toString().trim() === "SI");
					this.ss.setData({"precios_adicionales": is_precios});
                    resolve();
                },
                err => {
					this.ss.setData({"precios_adicionales": false});
                    reject(err);
                }
            );
        });
	}
	
	getPrecioUnitarioEditable(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_unitario_editable_id = 18;
            this.parametroService.getById(precio_unitario_editable_id).subscribe(
                res => {
					let is_precio_unitario_editable = (res.valor.toString().trim() === "1");
					this.ss.setData({"is_precio_unitario_editable": is_precio_unitario_editable});
					this.ss.setData
                    resolve();
                },
                err => {
					this.ss.setData({"is_precio_unitario_editable": false});
                    reject(err);
                }
            );
        });
	}
	
	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
					let numero_decimales = res.valor;
					
                    let digitos = "";
                    for(let i = 0; i < numero_decimales; i++) digitos += "0";

					this.ss.setData({"numero_decimales": numero_decimales});
					this.ss.setData({"format_decimal": "0,0." + digitos});
                    resolve();
                },
                err => {
                    //this.numero_decimales = 2;
					//this.format_decimal = "0,0.00"
					this.ss.setData({"numero_decimales": 2});
					this.ss.setData({"format_decimal": "0,0.00"});
                    reject(err);
                }
            );
        });
	}
	
	getIVA(){
		return new Promise((resolve, reject) => {
			this.parametroService.getById(1).subscribe(
				res => {
					this.ss.setData({"IVA": parseFloat(res.valor) / 100});
					this.ss.setData({"IVA_PARAM": res.valor});
					resolve();
				},
				err => {
					this.ss.setData({"IVA": 0});
					this.ss.setData({"IVA_PARAM": 0});
					reject(err);
				}
			);
		});
	}
	
	getParamDocumentoManual(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let documento_manual_id = 9;
            this.parametroService.getById(documento_manual_id).subscribe(
                res => {
					let is_numero_manual = (res.valor.toString().trim() === "SI");
					this.ss.setData({"is_numero_manual": is_numero_manual});
                    resolve();
                },
                err => {
					this.ss.setData({"is_numero_manual": false});
                    reject(err);
                }
            );
        });
	}
	//////////////////////////////////////////

	sidebarToggle(){
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        var sidebar = document.getElementsByClassName('navbar-collapse')[0];
        if(this.sidebarVisible == false){
            setTimeout(function(){
                toggleButton.classList.add('toggled');
            },500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
	}

	resetPassword(usuario){			
		let empresa = this.empresa;
		if(empresa.trim().length == 0){
			this.msgSweet.showMessage('error-message', "El campo empresa está vacio");
			return;
		}
		if( usuario.trim().length === 0 ){
			this.msgSweet.showMessage('error-message', "El campo usuario está vacio");
			return;
		}
		else{
			this.loginService.getCteByCodigo(empresa).subscribe(
				res => {
					let host_api = res.host_api;
					let dbname = res.dbname;

					sessionStorage.setItem('host_api', host_api);
					sessionStorage.setItem("dbname", dbname);

					this.usuarioService.olvideClave(usuario,host_api,dbname).subscribe(
						res => {
							this.msgSweet.showMessage('error-message', res.message);		
						},
						err=>{
							console.log('err',err);
						}
					);
				},
				err => {
					console.log('err',err);
				}
			);
		}


	}	

}
	
	




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/login/login-principal/login-principal.component.ts